import { Box, Typography, Paper } from "@mui/material";

const Solutions = () => {
  return (
    <Box sx={{ p: 2 }}>
      <Paper sx={{
 p: 3,
textAlign: "center" 
}}>
        <Typography variant="h6" color="text.secondary">
          Solutions Tab
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          This is where students will see solutions to their problems
        </Typography>
      </Paper>
    </Box>
  );
};

export default Solutions;
